import './Navbar.css';
import React from 'react';

export default function Navbar() {
    return (
        <nav className="NavbarContainer">
            <h1>Sorting Algorithm Visualizer</h1>
        </nav>
        
    )
}